import * as Immutable from 'seamless-immutable';
import {
  CURRENT_USER_FETCH_API_PENDING,
  CURRENT_USER_FETCH_API_FULFILLED,
  CURRENT_USER_FETCH_API_REJECTED
} from '../actions';

const initialState = Immutable.from({
  loading: true, // We assume that this data is fetched when the app is initialized
  error: null,
  attributes: null
});

export default (state = initialState, action) => {
  switch (action.type) {
    case CURRENT_USER_FETCH_API_PENDING:
      return initialState;
    case CURRENT_USER_FETCH_API_FULFILLED:
      return state.merge({
        loading: false,
        attributes: action.payload
      });
    case CURRENT_USER_FETCH_API_REJECTED:
      return state.merge({
        loading: false,
        error: action.payload
      });
    default:
      return state;
  }
};
